export default () => {
    const resizeObserver = new ResizeObserver((entries) => {
        entries.forEach(entry => {
            if (entry.target.parentNode.classList.contains('is-open')) {
                entry.target.style.height = entry.target.children[0].clientHeight + 'px';
            }
        })
    });

    const toggleEls = [...document.querySelectorAll('.js-toggle-accordion')];

    toggleEls.forEach(el => {
        const item = el.parentNode;
        const content = el.nextElementSibling;
        const group = item.parentNode;

        el.addEventListener('click', () => {
            if (item.classList.contains('is-open')) {
                item.classList.remove('is-open');
                el.setAttribute('aria-expanded', 'false');
                content.style.height = 0;
            } else {
                const openItems = [...group.children].filter((el) => el.classList.contains('is-open'));

                if (openItems) {
                    openItems.forEach(el => {
                        el.classList.remove('is-open');
                        el.firstElementChild.setAttribute('aria-expanded', 'false');
                        el.firstElementChild.nextElementSibling.style.height = 0;
                    });
                }

                item.classList.add('is-open');
                el.setAttribute('aria-expanded', 'true');
                content.removeAttribute('hidden');
                content.style.height = content.children[0].clientHeight + 'px';
            }
        });

        content.addEventListener('transitionend', () => {
            if (!item.classList.contains('is-open')) {
                content.setAttribute('hidden', '');
            }
        });

        resizeObserver.observe(content);
    });

    
}